/**
 * Created by stonewang on 2018/12/17.
 */
import React, { Component } from 'react';
import './PDFModal.css';
import {
  Button,
  Col,
  Form,
  Row,
  Table,
} from 'antd';
import {
  DmsTab,
} from 'Components';
import {
  addQuotation,
  updateQuotation,
  quotationDetail,
} from '../../service/quotation';
import {
  config,
  returnFloat,
} from 'Utils';
const FormItem = Form.Item;

class PDFModal extends Component{
  constructor (props) {
    super(props);
    this.state = {
      visible: false,
    };
  }
  printHandle = (e) => {
    // window.frames['onboarding'].print();
    window.print();
  };
  clostHandle = (e) => {
    this.setState({visible: false})
  };
  openHandle = () => {
    this.setState({visible: true})
  };
  setData = () => {
  }
  /*componentDidUpdate(prevProps, prevState, snapshot) {
    const {detail, productTableProps} = prevProps;
    if(prevState.visible && !!detail && !!productTableProps) {
      window.print();
    }
  }*/

  render () {
    const {detail, productTableProps} = this.props;
    if(this.state.visible && !!detail && !!productTableProps) {
      return <div className="printBox">
        <div><a onClick={this.printHandle}>[打印]</a>&nbsp;&nbsp;&nbsp;&nbsp;<a onClick={this.clostHandle}>[关闭]</a></div>
        {/*<iframe title="onboarding" name="onboarding" onLoad={this.setData} src={`https://view.officeapps.live.com/op/view.aspx?src=${docSrc}`} />*/}
        {/*<embed src={docSrc} type="application/msword" width="100%" height="100%" />*/}
        <DmsTab options={[`报价单详情`]} defaultKey={0}>
        </DmsTab>
        <div className="tab_individual add_product">
          <Form layout="inline">
            <div style={{ padding: '12px', background: '#fff' }}>
              <Row gutter={16}>
                <Col className="gutter-row" span={12}>
                  <FormItem label="报价单号：">
                    {detail.offerCode || ''}
                  </FormItem>
                </Col>
                <Col className="gutter-row" span={12}>
                  <FormItem label="客户名称">
                    {detail.customerName || ''}
                  </FormItem>
                </Col>
              </Row>
              <FormItem label="备注">
                <p>{detail.remark || ''}</p>
              </FormItem>
              <DmsTab options={['商品']} defaultKey={0}>
                {/*<Button onClick={() => this.goSelectProduct()}>添加</Button>*/}
                {/*&emsp;*/}
                {/*<Button onClick={() => this.deleteProduct()}>删除</Button>*/}
              </DmsTab>
              <div className="dms-table-box">
                <Table {...productTableProps} />
              </div>
              <div className="dms-split-bar"></div>
              <Row type="flex" justify="start" style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                <div style={{ width: 200, paddingRight: 10 }}>
                  <Row>
                    <Col span={11} style={{ textAlign: 'right' }}>商品总金额：</Col>
                    <Col span={13}><p style={{ textAlign: 'right' }}><span className="dms-red">{returnFloat(detail.amount)}</span></p></Col>
                  </Row>
                  <Row>
                    <Col span={11} style={{ textAlign: 'right' }}>优惠金额：</Col>
                    <Col span={13}><p style={{ textAlign: 'right' }}><span className="dms-red">{returnFloat(detail.downAmount)}</span></p></Col>
                  </Row>
                  <Row>
                    <Col span={11} style={{ textAlign: 'right' }}>整单折扣：</Col>
                    <Col span={13}><p style={{ textAlign: 'right' }}><span className="dms-red">{returnFloat(detail.discountAmount)}</span></p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={11} style={{ textAlign: 'right' }}>实际总金额：</Col>
                    <Col span={13}><p style={{ textAlign: 'right' }}><span className="dms-red">{returnFloat(detail.realityAmount)}</span></p></Col>
                  </Row>
                </div>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    } else {
      return null
    }
  }
}
export default PDFModal



// WEBPACK FOOTER //
// ./src/routes/quotation/PDFModal.js